import get from 'lodash/get';
import moment from 'moment';
import { createSelector } from 'reselect';

import { plansForBilling } from 'helpers/planHelpers';
import { priceIdKeySelector } from './user';
import { subscriptionsSelector } from './subscriptions';

const basePlansSelector = (state) => get(state, 'plans.plans', []);
export const plansSelector = createSelector(basePlansSelector, (plans) => plans);

export const plansForBillingSelector = createSelector(
  subscriptionsSelector,
  plansSelector,
  priceIdKeySelector,
  (subscription, plans, priceIdKey) => plansForBilling(plans, subscription, priceIdKey),
);

export const currentPlanForBillingSelector = createSelector(
  subscriptionsSelector,
  plansForBillingSelector,
  (subscription, plans) => plans.find((item) => get(item, '_id') === get(subscription, 'plan._id')),
);

const baseCheapestPlansSelector = (state) => get(state, 'plans.cheapestPlans', []);
export const cheapestPlansSelector = createSelector(baseCheapestPlansSelector, (plans) => plans);

const basePhoneSearchProPlanSelector = (state) => get(state, 'plans.phoneSearchProPlan', []);
export const phoneSearchProPlanSelector = createSelector(basePhoneSearchProPlanSelector, (plan) => plan);

const baseEmailVerificationCreditsPlanSelector = (state) => get(state, 'plans.emailVerificationCreditsPlan', []);
export const emailVerificationCreditsPlanSelector = createSelector(
  baseEmailVerificationCreditsPlanSelector,
  (plan) => plan,
);

const basePhoneNumbersCreditsPlanSelector = (state) => get(state, 'plans.phoneNumbersCreditsPlan', []);
export const phoneNumbersCreditsPlanSelector = createSelector(basePhoneNumbersCreditsPlanSelector, (plan) => plan);

export const plansWithCheapPricesSelector = createSelector(plansSelector, (plans) =>
  plans.filter((plan) => plan.prices && plan.prices.some((price) => price.isCheap)),
);

export const pauseDiscountSelector = (plan) =>
  createSelector(subscriptionsSelector, (subscription) => {
    const hasPauseDiscount =
      !plan?.isCustom &&
      subscription?.status === 'pause' &&
      moment().diff(subscription?.pauseData?.pauseSetAt, 'month') >= 1;
    return hasPauseDiscount ? 30 : 0;
  });
